export enum NewFlowTabs {
  FlowInfo = "1",
  Steps = "2",
  AssignRole = "3",
  FlowAction = "4",
}
